module.exports = __webpack_public_path__ + "static/icons/icon-chevron-left--white-e4a112f4c6c617d6212e2239cf54a70f.svg";